/* eslint-disable import/no-duplicates */
/* eslint-disable no-unused-vars */
import React from 'react';
import { Route } from 'react-router-dom';
import Dashboardsearch from '../Dashboard/dashboard';
import UserDefault from '../../Modules/System/UserDefault/Components/UserDefault';
import CodeTablesNew from '../../Modules/System/codeTablesNew/Components/CodeTables';
import CodeTables from '../../Modules/System/codeTables/Components/CodeTableNew';
import ContactType from '../../Modules/contactType/components/ContactTypeNew';
import PriceType from '../../Modules/System/priceType/components/priceType';
import ProcedureResultDetails from '../../Modules/System/ProcedureResult/component/ProcedureResultDetails';
import ProcedureResults from '../../Modules/System/ProcedureResult/component/ProcedureResult';
import ReminderSetup from '../../Modules/System/ReminderSetup/components/ReminderSetup';
import ReminderRecipientsComponent from '../../Modules/System/ReminderRecipients/components/ReminderRecipientsComponent';
import TBill from '../../Modules/Maintain/tBillRates/Components/tBill';
import Client from '../../Modules/Maintain/client/Components/gridComponents/searchClient';
import Group from '../../Modules/Maintain/group/Components/group';
import GroupMaintain from '../../Modules/Maintain/group/Components/maintainGroup';
import Maintain from '../../Modules/Maintain/client/Components/maintain';
import CopyContact from '../../Modules/Maintain/client/Components/copyContact';
import provider from '../../Modules/Display/Provider/Components/provider';
import NDC from '../../Modules/Display/NDC/index';
import NDCDetails from '../../Modules/Display/NDC/component/NDCDetails/index';
import ProviderDetails from '../../Modules/Display/Provider/Components/providerDetails';
import BasicTabs from '../../Modules/System/systemParameter/components/systemParameter';
import Plan from '../../Modules/Maintain/Plan/component/planForms';
import createNewPlanForm from '../../Modules/Maintain/Plan/component/createNewPlanForm';
import RequestInvoiceDetails from '../../Modules/Display/invoice/Components/requestInvoiceDetails';
import DisplayInvoice from '../../Modules/Display/invoice/Components/displayInvoice';
import ClaimDetails from '../../Modules/Display/ClaimDetails/Components/claimDetails';
import InvoiceAuditsSearch from '../../Modules/Research/InvoiceAudits/components/InvoiceAuditsSearch';
import InvoiceAuditViewDetails from '../../Modules/Research/InvoiceAudits/components/InvoiceAuditViewDetails';
import DrugFileSearch from '../../Modules/Research/CMSDrugFileDiscrepancies/components/DrugFileSearch';
import DrugFileDetails from '../../Modules/Research/CMSDrugFileDiscrepancies/components/DrugFileDetails';
import ClaimAuditViewDetails from '../../Modules/Research/ClaimAudits/components/ClaimAuditViewDetails';
import DisplayLetterSearch from '../../Modules/Display/Letter/components/DisplayLetterSearch';
import DIsplayLetterDetail from '../../Modules/Display/Letter/components/DisplayLetterDetail';
import Wip from '../WIP/Wip';
import Collectionletterdetail from '../../Modules/Tasks/GenerateCollectionLetter/components/Collectionletterdetail';
import CmsRosiSearch from '../../Modules/Research/CMSROSI/components/CmsRosiSearch';
import CmsRosiDetails from '../../Modules/Research/CMSROSI/components/CmsRosiDetails';
import ContactAnomalies from '../../Modules/Research/ContactAnomalies/components/ContactAnomalies';
import UnderThresholdInvoiceSearchComponent from '../../Modules/Research/UnderThresholdInvoices/Components/UnderThresholdInvoiceSearchComponent';
import DisplayUnderThresholdInvoices from '../../Modules/Research/UnderThresholdInvoices/Components/DisplayUnderThresholdInvoices';
import RequestInvoiceReport from '../../Modules/Display/InvoiceReport/Components/requestInvoiceReport';
import RequestInvoiceReportDetails from '../../Modules/Display/InvoiceReport/Components/requestInvoiceReportDetails';
import EventLogging from '../../Modules/System/EventLogging/component/EventLogging';
// Maintain > Manufacturer routes
import ManufacturerSearch from '../../Modules/Maintain/Manufacturer/components/ManufacturerSearch';
import AddEditManufacturer from '../../Modules/Maintain/Manufacturer/components/AddEditManufacturer';
// Maintain > Excluded NDCs
import ExcludedNDCsSearch from '../../Modules/Maintain/excludedNDCs/Components/ExNDCsSearch';
import ExcludedNDCsDetail from '../../Modules/Maintain/excludedNDCs/Components/ExNDCsDetailList';
// Maintain > Letter Template
import LetterTemplateSearch from '../../Modules/Maintain/LetterTemplate/Components/LetterTemplateSearch';
import LetterTemplateDetail from '../../Modules/Maintain/LetterTemplate/Components/LetterTemplateDetail';
import DisplayLetterPreview from '../../Modules/Maintain/LetterTemplate/Components/DisplayLetterPreview';

import UnitConversion from '../../Modules/Maintain/unitConversion/unitConversion';
import UnitConversionDetail from '../../Modules/Maintain/unitConversion/detailList';

import RequestInvoiceCalculation from '../../Modules/Invoice/RequestInvoiceCalculation/Components/requestInvoiceCalcation';
import RequestURACalculation from '../../Modules/Invoice/RequestURACalculation/Components/requestURACalcation';
import CreateUtilizationTape from '../../Modules/Invoice/CreateUtilizationTape/Components/createUtilizationTape';
import RecordMailingDate from '../../Modules/Invoice/RecordMailingDate/Components/recordMailingDate';
import ineligibleProviders from '../../Modules/Maintain/IneligibleProviders/Components/ineligibleProviders';
// export default routes;
// Check routes
import CheckSearch from '../../Modules/Maintain/Check/component/CheckSearch';
import MaintainCheck from '../../Modules/Maintain/Check/component/MaintainCheck';
import AssignDisputesSearch from '../../Modules/Tasks/AssignDisputesSearch';
import AssignDisputesDetails from '../../Modules/Tasks/AssignDisputesDetail';

// Maintain > COntract
import ContractSearch from '../../Modules/Maintain/Contract/components/ContractSearch';

// Tasks
import RequestClaimAudit from '../../Modules/Tasks/RequestClaimAudit';
import ChecksByInvoice from '../../Modules/Tasks/CheckByInvoices/component/ChecksByInvoice';
import MailingLabel from '../../Modules/Tasks/MailingLabelRequest/Components/RequestMailingLabels';
import LinkNewDrugs from '../../Modules/Tasks/LinkNewDrugsToDrugFamily/components/LinkNewDrugs';
import SearchCheck from '../../Modules/Tasks/ViewCheckAllocation/components/SearchCheck';
import ViewCheckAllocation from '../../Modules/Tasks/ViewCheckAllocation/components/ViewCheckAllocation';
import RequestCurrentDisputeDisplay from '../../Modules/Tasks/PerformDisputeResolutions/components/RequestCurrentDisputeDisplay';
import DisplayCurrentDisputes from '../../Modules/Tasks/PerformDisputeResolutions/components/DisplayCurrentDisputes';
// Task > Log Batch Total
import LogBatchTotalSearch from '../../Modules/Tasks/LogBatchTotal/components/LogBatchTotalSearch';
import LogBatchTotalForm from '../../Modules/Tasks/LogBatchTotal/components/LogBatchTotalForm';
// tasks > Log check
import LogCheckComponent from '../../Modules/Tasks/LogCheck/components/LogCheckComponent';
import SuspendedCheckComponent from '../../Modules/Research/SuspendedChecks/components/SuspendedCheckComponent';
// tasks >Calculate Interest
import CalculateInterestSearch from '../../Modules/Tasks/CalculateInterest/components/CalculateInterestSearch';
// system >comment&correspondence
import CommentAndCorrespondenceComponent from '../../Modules/System/commentsAndCorrespondence/components/CommentAndCorrespondenceComponent';
import claim from '../../Modules/Display/Claim/claim';
import SelectedClaim from '../../Modules/Display/Claim/component/SelectedClaim';
import maintainMatDrug from '../../Modules/CMS/MaintainMATDrug/Components/maintainMatDrug';
import FreezeInvoice from '../../Modules/Invoice/FreezeInvoice/Components/freezeInvoice';
import GenerateInvoice from '../../Modules/Invoice/GenerateInvoice/Components/GenerateInvoiceSearchCom';
import GenerateInvoiceDetails from '../../Modules/Invoice/GenerateInvoice/Components/GenerateInvoiceDetailsCom';
import DrugFamily from '../../Modules/Maintain/DrugFamily/DrugFamilySearch';
import DrugFamilyDetails from '../../Modules/Maintain/DrugFamily/DrugFamilyDetails';
import LabelerDifferences from '../../Modules/Research/LabelerDifferences/component/LabelerDifferences';
import DisplayCheck from '../../Modules/Display/Check/displaycheck';
import unfreezeInvoice from '../../Modules/System/TechnicalWindow/OnlineFixes/UnfreezeInvoice/components/unfreezeInvoice';
import removeSuspendedDt from '../../Modules/System/TechnicalWindow/OnlineFixes/RemoveSuspendedDt/Components/removeSuspendedDt';
import TechnicalWindow from '../../Modules/System/TechnicalWindow/components/technicalWindow';
import OnlineFixes from '../../Modules/System/TechnicalWindow/OnlineFixes/components/onlineFixes';
import CreateContract from '../../Modules/Maintain/Contract/components/CreateContract';
import CmsMismatch from '../../Modules/Research/CMSMismatch/components/CmsMismatch';
import CmsMismatchDetails from '../../Modules/Research/CMSMismatch/components/CmsMismatchDetails';
import RequestDrugPriceLoad from '../../Modules/Invoice/RequestDrugPriceLoad/RequestDrugPriceLoad';
import RequestDrugPriceLoadDetails from '../../Modules/Invoice/RequestDrugPriceLoad/component/RequestDrugPriceLoadDetails/RequestDrugPriceLoadDetails';
import DeleteCheckLog from '../../Modules/System/TechnicalWindow/OnlineFixes/DeleteCheckLog/DeleteCheckLog';
import RequestPreviousClaim from '../../Modules/System/TechnicalWindow/OnlineFixes/RequestedPreviousClaim/RequestedPreviousClaim';
import RequestDeleteBatch from '../../Modules/System/TechnicalWindow/OnlineFixes/RequestDeleteBatch/RequestDeleteBatch';
import PeriodicReport from '../../Modules/System/TechnicalWindow/PeriodicReport/PeriodicReport';
import CreateStubInvoice from '../../Modules/System/TechnicalWindow/OnlineFixes/CreateStubInvoice/CreateStubInvoice';
import claimAuditSelect from '../../Modules/Research/ClaimAudits/components/ClaimAuditSelect';
//import ClaimAuditViewDetails from '../../Modules/Research/ClaimAudits/components/ClaimAuditViewDetails';
import TransitionData from '../../Modules/System/TechnicalWindow/TransitionData/TransitionData';
import GenerateCollectionLetter from '../../Modules/Tasks/GenerateCollectionLetter/components/generateCollectionLetter';

// account receivabale
import ReqAccReceivable from '../../Modules/Research/AccountReceivable/ReqAccReceivable';
import ArSummaryByMfg from '../../Modules/Research/AccountReceivable/ARSummaryByMfg';
import ArSummaryByMfgAll from '../../Modules/Research/AccountReceivable/ARSummaryByMfgAll';
import ARManufacturer from '../../Modules/Research/AccountReceivable/ARManufacturer';
import AccRecNDCActivity from '../../Modules/Research/AccountReceivable/AccRecNDCActivity';
import AccRecNDCDetail from '../../Modules/Research/AccountReceivable/AccRecNDCDetail';
import AccRecNDCDetailAll from '../../Modules/Research/AccountReceivable/AccRecNDCDetailAll';
import ARSummaryByQtr from '../../Modules/Research/AccountReceivable/ARSummaryByQtr';
import ARSummaryByQtrAll from '../../Modules/Research/AccountReceivable/ARSummaryByQtrAll';
import QtrAccountsRec from '../../Modules/Research/AccountReceivable/QtrAccountsRec';
import QtrAccountsRecAll from '../../Modules/Research/AccountReceivable/QtrAccountsRecAll';
import MfgAccountsRec from '../../Modules/Research/AccountReceivable/MfgAccountsRec';

// Disputes
import DisputesSearch from '../../Modules/Research/Disputes/components/index';
import ManufacturerDisputesDetail from '../../Modules/Research/Disputes/components/disputesDetail';
import NDCDisputesDetails from '../../Modules/Research/Disputes/components/disputesNDCDetail';
// Rebateprogram
import MaintainRebate from '../../Modules/Maintain/RebateProgram/MaintainRebate';
import SearchRebate from '../../Modules/Maintain/RebateProgram/SearchRebate/index';
import CreateRebate from '../../Modules/Maintain/RebateProgram/CreateRebate';
// PriceLevel
import PriceLevelSearch from '../../Modules/Maintain/RebatePriceLevel/Components/PriceLevelSearch';
// Create Letter
import CreateLetter from '../../Modules/Tasks/CreateLetter/Components/CreateLetter';
import CreateLetterDetail from '../../Modules/Tasks/CreateLetter/Components/CreateLetterdetail/CreateLetterDetail';
import MaintainPriceDetails from '../../Modules/Maintain/RebatePriceLevel/Components/MaintainPriceDetails';
// CMS ROSI/PQAS Inconsistencies
import CMSInconsistenciesSearch from '../../Modules/Research/CMSRPInconsistencies/components/index';
import CMSInconsistenciesDetails from '../../Modules/Research/CMSRPInconsistencies/components/inconsistencyDetail';
import QuarterlyMarketingData from '../../Modules/System/TechnicalWindow/QuarterlyMarketingData/QuarterlyMarketingData';
import QuarterlyMarketingDataTableDetails from '../../Modules/System/TechnicalWindow/QuarterlyMarketingData/components/QuarterlyMarketingDataTableDetails';
// PriceDetailsSearch
import RebatePriceSearch from '../../Modules/Maintain/RebatePriceDetails/components/RebatePriceSelect';
import RebatePriceDetails from '../../Modules/Maintain/RebatePriceDetails/components/RebatePriceDetails';
// Summary Reports
import DisplayQuarterlyPayments from '../../Modules/Reports/QuarterlyPayments/Components/DisplayQuarterlyPayments';
import RequestQuarterlyPayment1 from '../../Modules/Reports/QuarterlyPayments/Components/RequestQuarterlyPayment';
import RequestInvoicesQtrnotPaid from '../../Modules/Reports/InvoicesQtrnitPaid/Components/RequestInvoicesQtrnotPaid';
import DisplayInvoicesQtrnotPaid from '../../Modules/Reports/InvoicesQtrnitPaid/Components/DisplayInvoicesQtrnotPaid';

import ProviderReview from '../../Modules/Tasks/ProviderReview/ProviderReview';
import ProviderReviewDetail from '../../Modules/Tasks/ProviderReview/ProviderReviewDetail';
import ProviderSummary from '../../Modules/Tasks/PerformDisputeResolutions/components/ProviderSummary';
import DisputedClaimsDetail from '../../Modules/Tasks/PerformDisputeResolutions/components/DisputedClaimsDetail';
import NDCHistory from '../../Modules/Tasks/PerformDisputeResolutions/components/NDCHistory';
// allocate Payment
import SearchAllocatePaymentComponent from '../../Modules/Tasks/AllocatePayments/components/SearchAllocatePaymentComponent';
import SearchPickInvAssociateWithCheckCom from '../../Modules/Tasks/AllocatePayments/components/SearchPickInvAssociateWithCheckCom';
import DetailScreenAllocatePaymentComponent from '../../Modules/Tasks/AllocatePayments/components/DetailScreenAllocatePaymentComponent';

// summaryReports
import PaymentSummary from '../../Modules/Reports/PaymentSummary/PaymentSummary';
import DisplayPaymentSummary from '../../Modules/Reports/PaymentSummary/DisplayPaymentSummary';
import RebateSummary from '../../Modules/Reports/summaryReports/RebateSummary';
import RebatePercentOfSpend from '../../Modules/Reports/RebatePercentOfSpend/Components/RebatePercentOfSpend';
import DisplayPercent from '../../Modules/Reports/RebatePercentOfSpend/Components/DisplayPercent';
import InvoiceRegister from '../../Modules/Reports/InvoiceRegister/Components/InvoiceRegister';
import DisplayInvoiceRegister from '../../Modules/Reports/InvoiceRegister/Components/DisplayInvoiceRegister';
import TopBalances from '../../Modules/Reports/TopBalances/TopBalances';
import DisplayTopBalances from '../../Modules/Reports/TopBalances/DisplayTopBalances';
import DisputeActivity from '../../Modules/Reports/DisputeActivity/Components/DisputeActivity';
import DisplayDisputeActivity from '../../Modules/Reports/DisputeActivity/Components/DisplayDisputeActivity';
import ReqInitCorrectCmsReport from '../../Modules/System/TechnicalWindow/OnlineFixes/ReqInitCorrectCmsReport/components/ReqInitCorrectCmsReport';
import CalculatedInterest from '../../Modules/Display/CalculatedInterest';
import CalculatedInterestDetails from '../../Modules/Display/CalculatedInterest/component/CalculatedInterestDetails';
import URASearch from '../../Modules/Display/URASearch/components/URASearch';
import SelectedURA from '../../Modules/Display/URASearch/components/Selected-URA/SelectedURA';
import ResearchExistingCMSReport from '../../Modules/System/TechnicalWindow/OnlineFixes/ResearchExistingCMS64Report/ResearchExistingCMSReport';
import ResearchExistingCMS64ReportDetails from '../../Modules/System/TechnicalWindow/OnlineFixes/ResearchExistingCMS64Report/components/ResearchExistingCMS64ReportDetails';

import RequestDisputeAmount from '../../Modules/Reports/DisputeAmmount/Components/RequestDisputeAmount';
import DisplayManufacturerDisputedAmounts from '../../Modules/Reports/DisputeAmmount/Components/DisplayManufacturerDisputedAmounts';
import InitCorrectCmsReport from '../../Modules/System/TechnicalWindow/OnlineFixes/ReqInitCorrectCmsReport/components/InitCorrectCmsReport';
import DrugTypeSummary from '../../Modules/Reports/DrugTypeSummary/Components/DrugTypeSummary';
import UnallocatedBalance from '../../Modules/Reports/UnallocatedReports/components/UnallocatedBalance';
import UnallocatedBalanceDisplay from '../../Modules/Reports/UnallocatedReports/components/UnallocatedBalanceDisplay';

import DisplayDrug from '../../Modules/Reports/DrugTypeSummary/Components/DisplayDrug';
import HcpcsCodeClaimsPaid from '../../Modules/Reports/HcpcsCodeClaimsPaid/Components/HcpcsCodeClaimsPaid';
import DisplayHcpcsCode from '../../Modules/Reports/HcpcsCodeClaimsPaid/Components/DisplayHcpcsCode';
import CheckAllocationComparisionDisplay from '../../Modules/Reports/CheckAllocationComparison/Components/CheckAllocationComparisionDisplay';
import CheckAllocationComparisionSearch from '../../Modules/Reports/CheckAllocationComparison/Components/CheckAllocationComparisionSearch';
import ReqCurrentZeroURA from '../../Modules/Reports/CurrentZeroURA/Components/ReqCurrentZeroURA';
import DispCurrentZeroURA from '../../Modules/Reports/CurrentZeroURA/Components/DispCurrentZeroURA';
import InterestOverrideDetail from '../../Modules/Reports/InerestOverride/Components/InterestOverrideDetail';
import InterestOverrideRequest from '../../Modules/Reports/InerestOverride/Components/InterestOverrideRequest';
import InterestRecievedRequest from '../../Modules/Reports/InterestRecieved/Components/InterestRecievedRequest';
import InterestRecievedDetail from '../../Modules/Reports/InterestRecieved/Components/InterestRecievedDetail';
import ClaimGroupingParameter from '../../Modules/System/claimGroupingParameter/components/ClaimGroupingParameter';
import ReqNDCDetails from '../../Modules/Reports/NDCDetails/Components/ReqNDCDetails';
import ReqZeroURA from '../../Modules/Reports/ZeroURA/Components/ReqZeroURA';
import DispZeroURA from '../../Modules/Reports/ZeroURA/Components/DispZeroURA';

import ClaimGroupingParameterDetail from '../../Modules/System/claimGroupingParameter/components/ClaimGroupingParameterDetail';
import ResearchExistingCMS64InvoiceAmount from '../../Modules/System/TechnicalWindow/OnlineFixes/ResearchExistingCMS64Report/components/ResearchExistingCMS64InvoiceAmount';
import ResearchExistingCMS64Adjustments from '../../Modules/System/TechnicalWindow/OnlineFixes/ResearchExistingCMS64Report/components/ResearchExistingCMS64Adjustments';
import ResearchExistingCMS64Payments from '../../Modules/System/TechnicalWindow/OnlineFixes/ResearchExistingCMS64Report/components/ResearchExistingCMS64Payments';
import DisputeCodes from '../../Modules/Reports/DisputeCodes/Components/DisputeCodes';
import DisplayDisputeCodes from '../../Modules/Reports/DisputeCodes/Components/DisplayDisputeCodes';
import OutstandingDisputesForQuarter from '../../Modules/Reports/OutstandingDisputesForQuarter/Components/OutstandingDisputesForQuarter';
import DisplayOutstandingDisputesForQuarter from '../../Modules/Reports/OutstandingDisputesForQuarter/Components/DisplayOutstandingDisputesForQuarter';
import DisputeRecapitulation from '../../Modules/Reports/DisputeRecapitulation/Components/DisputeRecapitulation';
import DisplayDisputeRecapitulation from '../../Modules/Reports/DisputeRecapitulation/Components/DisplayDisputeRecapitulation';
import ReqOutstandingDisputesNumOfDays from '../../Modules/Reports/OutstandingDisputesForNumOfDays/Components/ReqOutstandingDisputesNumOfDays';
import DispOutstandingDisputesNumOfDays from '../../Modules/Reports/OutstandingDisputesForNumOfDays/Components/DispOutstandingDisputesNumOfDays';
import DisplayNDCDetails from '../../Modules/Reports/NDCDetails/Components/DisplayNDCDetails';
import DisplayNDCHistory from '../../Modules/Reports/NDCHistory/Components/DisplayNDCHistory';
import ReqNDCHistory from '../../Modules/Reports/NDCHistory/Components/ReqNDCHistory';
import RequestMCOClaims from '../../Modules/Reports/MCOClaims/Components/RequestMCOClaims';
import DisplayMCOClaims from '../../Modules/Reports/MCOClaims/Components/DisplayMCOClaims';

import AdjustmentByReasonCode from '../../Modules/Reports/AdjustmentByReasonCode/Components/ReqAdjustmentReasonCode';
import DispAdjustmentReasonCode from '../../Modules/Reports/AdjustmentByReasonCode/Components/DispAdjustmentReasonCode';

import ReqInstitutionalClaim from '../../Modules/Reports/InstitutionalClaimUnitTypeDiscrepancy/Components/ReqInstitutionalClaim';
import DispInstitutionalClaim from '../../Modules/Reports/InstitutionalClaimUnitTypeDiscrepancy/Components/DispInstitutionalClaim';
import About from '../../Modules/Help/about/components/about';
import RequestContract from '../../Modules/Reports/Contract/Components/RequestConstract';
import Rosi from '../../Modules/Reports/RosiPqas/Components/Rosi';
import DisplayRosi from '../../Modules/Reports/RosiPqas/Components/DisplayRosi';
import CmsUra from '../../Modules/Reports/CmsUroa/Components/CmsUra';
import DisplayCms from '../../Modules/Reports/CmsUroa/Components/DisplayCms';
import CmsDrug from '../../Modules/Reports/CmsDrug/Components/CmsDrug';
import DisplayCmsDrug from '../../Modules/Reports/CmsDrug/Components/DisplayCmsDrug';

import { Provider } from 'react-redux';
import BProviderClaim from '../../Modules/Reports/ProviderClaim/components/BProviderClaim';
import DisplayBprovider from '../../Modules/Reports/ProviderClaim/components/DisplayBprovider';

import PreInvoice from '../../Modules/Reports/PreInvoiceUnitAdjustment/Components/PreInvoice';
import DisplayPreInvoice from '../../Modules/Reports/PreInvoiceUnitAdjustment/Components/DisplayPreInvoice';
import ProgramAndEligibility from '../../Modules/Reports/ProgramAndEligibility/Components/ProgramAndEligibility';
import DisplayProgramAndEligibility from '../../Modules/Reports/ProgramAndEligibility/Components/DisplayProgramAndEligibility';
import TotalDollersPaid from '../../Modules/Reports/TotalDollersPaid/Components/TotalDollersPaid';
import RequestCurrentToPrevious from '../../Modules/Reports/CurrentToPreviousQuarter/Components/RequestCurrentToPrevious';
import DisplayCurrentToPrevious from '../../Modules/Reports/CurrentToPreviousQuarter/Components/DisplayCurrentToPrevious';
import ReqCashReceiptSummary from '../../Modules/Reports/CashReceiptSummary/Components/ReqCashReceiptSummary';
import DispCashReceiptSummary from '../../Modules/Reports/CashReceiptSummary/Components/DispCashReceiptSummary';
import CmsReport from '../../Modules/Reports/CmsReportAdjustment/Components/CmsReport';
import DisplayCmsReport from '../../Modules/Reports/CmsReportAdjustment/Components/DisplayCmsReport';
import ReqOutstandingByLabererAndQuarter from '../../Modules/Reports/OutstandingBalanceByLabererAndQuarter/Components/ReqOutstandingByLabererAndQuarter';
import DisOutstandingByLabererAndQuarter from '../../Modules/Reports/OutstandingBalanceByLabererAndQuarter/Components/DisOutstandingByLabererAndQuarter';
import ReqManufacturerSummary from '../../Modules/Reports/ManufacturerSummary/Components/ReqManufacturerSummary';
import DispManufacturerSummary from '../../Modules/Reports/ManufacturerSummary/Components/DispManufacturerSummary';
import ReqNDCPayment from '../../Modules/Reports/NDCPayment/Components/ReqNDCPayment';
import DispNDCPayment from '../../Modules/Reports/NDCPayment/Components/DispNDCPayment';
import AdjustedClaims from '../../Modules/Reports/AdjustedClaims/Components/AdjustedClaims';
import DisplayAdjustedClaims from '../../Modules/Reports/AdjustedClaims/Components/DisplayAdjustedClaims';
import RequestFamilyPlanningDrugsInvoicedRebates from '../../Modules/Reports/FamilyPlanningDrugsInvoicedforRebates/Components/ReqFamilyPlanningDrugsInv';
import DisplayFamilyPlanningDrugsInvoicedRebates from '../../Modules/Reports/FamilyPlanningDrugsInvoicedforRebates/Components/DisplayFamilyPlanningDrugsInv';
import RequestFamilyPlanningDrugsPmtRec from '../../Modules/Reports/FamilyPlanningDrugsPaymentReceived/Components/ReqFamilyPlanningDrugsPmtRec';
import DisplayFamilyPlanningDrugsPmtRec from '../../Modules/Reports/FamilyPlanningDrugsPaymentReceived/Components/DisplayFamilyPlanningDrugsPmtRec';
import ReqExcludedClaims from '../../Modules/Reports/ExcludedClaims/Components/ReqExcludedClaims';
import DispExcludedClaims from '../../Modules/Reports/ExcludedClaims/Components/DispExcludedClaims';
import ActiveLabeler from '../../Modules/Reports/ActiveLabeler/Components/ActiveLabeler';
import DisplayActiveLabeler from '../../Modules/Reports/ActiveLabeler/Components/DisplayActiveLabeler';
import UserList from '../../Modules/System/UserList/Components/UserList';
import ReqChipCshcnRates from '../../Modules/Reports/ChipCshcnRates/Components/ReqChipCshcnRates';
import DispChipCshcnRates from '../../Modules/Reports/ChipCshcnRates/Components/DispChipCshcnRates';
import RequestDrugsTherapeuticClass from '../../Modules/Reports/DrugsTherapeuticClass/Components/ReqDrugsTherapeuticClass';
import DisplayDrugsTherapeuticClass from '../../Modules/Reports/DrugsTherapeuticClass/Components/DisplayDrugsTherapeuticClass';
import TerminatedLabelerRequest from '../../Modules/Reports/TerminatedLabeler/Components/TerminatedLabelerRequest';
import TerminatedLabelerDetail from '../../Modules/Reports/TerminatedLabeler/Components/TerminatedLabelerDetail';
import QuarterlyClaimReconcilliationRequest from '../../Modules/Reports/QuarterlyClaimsReconcilliation/Components/QuarterlyClaimReconcilliationRequest';
import QuarterlyClaimReconcilliationDetail from '../../Modules/Reports/QuarterlyClaimsReconcilliation/Components/QuarterlyClaimReconcilliationDetail';
import ReqChipCshcnRateAudit from '../../Modules/Reports/ChipCshcnRateAudit/Components/ReqChipCshcnRateAudit';
import DispChipCshcnRateAudit from '../../Modules/Reports/ChipCshcnRateAudit/Components/DispChipCshcnRateAudit';
import SupplementalRates from '../../Modules/Reports/SupplementalRates/Components/SupplementalRates';
import DisplaySupplementalRates from '../../Modules/Reports/SupplementalRates/Components/DisplaySupplementalRates';
import UnitAdjustment from '../../Modules/Reports/UnitAdjustmentatNDCLevel/Components/UnitAdjustment';
import DisplayUnitAdjustment from '../../Modules/Reports/UnitAdjustmentatNDCLevel/Components/DisplayUnitAdjustment';
import ReqManufacturerOutstandingBal from '../../Modules/Reports/ManufacturerOutstandingBalance/Components/ReqManufacturerOutstandingBal';
import DisManufacturerOutstandingBal from '../../Modules/Reports/ManufacturerOutstandingBalance/Components/DisManufacturerOutstandingBal';
import SubstanceAbuse from '../../Modules/Reports/SubstanceAbuse/Components/SubstanceAbuse';
import DisplaySubstanceAbuse from '../../Modules/Reports/SubstanceAbuse/Components/DisplaySubstanceAbuse';
import DProviderClaim from '../../Modules/Reports/DProviderClaim/Components/DProviderClaim';
import DisplayDProviderClaim from '../../Modules/Reports/DProviderClaim/Components/DisplayDProviderClaim';
import MonthlyClaimReconcilliationRequest from '../../Modules/Reports/MonthlyClaimsReconcilliation/Components/MonthlyClaimReconcilliationRequest';
import MonthlyClaimReconcilliationDetail from '../../Modules/Reports/MonthlyClaimsReconcilliation/Components/MonthlyClaimReconcilliationDetail';
import RequestRider from '../../Modules/Reports/Rider/Components/RequestRider';
import DisplayRider from '../../Modules/Reports/Rider/Components/DisplayRider';
import ReqQuarterlyReporting from '../../Modules/CMS/CMSQuarterlyReporting/Components/ReqQuarterlyReporting';
import DisQuarterlyReporting from '../../Modules/CMS/CMSQuarterlyReporting/Components/DisQuarterlyReporting';
import UnitsClaim from '../../Modules/Maintain/NumberOfUnits/unitsClaim';
import UnitsSelectedClaim from '../../Modules/Maintain/NumberOfUnits/component/UnitsSelectedClaim';
import AddorDeleteLoadLogEmail from '../../Modules/System/AddorDeleteLoadLogEmail';
import UpdateParamGeneral from '../../Modules/System/UpdateParamGeneral';
import SystemReminderComponent from '../../Modules/System/SystemReminder/components/SystemReminderComponent';
import MaintainIneligibleCPTComponent from '../../Modules/Maintain/MaintainIneligibleCPT/Components/MaintainIneligibleCPTComponent';
import RequestDataNicheReportComponent from '../../Modules/Tasks/RequestDataNicheReport/Components/RequestDataNicheReportComponent';
import FOOTERLINKS from '../../Modules/ContentManagement/FooterLinks';
import SITEMAP from '../../Modules/ContentManagement/footerLinks/SiteMap';

export default function RoutesApp() {
  return (
    <React.Fragment // uuid={props.uuid}
    >
      <Route exact path="/" component={Dashboardsearch} />
      <Route path="/dashboard" component={Dashboardsearch} />
      <Route exact path="/userDefault" component={UserDefault} />
      <Route exact path="/maintainRebate" component={MaintainRebate} />
      <Route exact path="/drugFamily" component={DrugFamily} />
      <Route exact path="/drugFamilyDetail" component={DrugFamilyDetails} />
      <Route exact path="/reqAccReceivable" component={ReqAccReceivable} />
      <Route exact path="/arSummaryByMfg/:id" component={ArSummaryByMfg} />
      <Route exact path="/mfgAccountRec/:id" component={MfgAccountsRec} />
      <Route exact path="/arSummaryByMfgAll" component={ArSummaryByMfgAll} />
      <Route exact path="/arSummaryByQtrAll" component={ARSummaryByQtrAll} />
      <Route exact path="/ARManufacturer" component={ARManufacturer} />
      <Route exact path="/AccRecNDCActivity" component={AccRecNDCActivity} />
      <Route exact path="/AccRecNDCDetail/:id" component={AccRecNDCDetail} />
      <Route exact path="/AccRecNDCDetailAll" component={AccRecNDCDetailAll} />
      <Route exact path="/ARSummaryByQtr/:id" component={ARSummaryByQtr} />
      <Route exact path="/QtrAccountsRec/:id" component={QtrAccountsRec} />
      <Route exact path="/QtrAccountsRecAll" component={QtrAccountsRecAll} />
      <Route exact path="/createNewPlan" component={createNewPlanForm} />
      <Route exact path="/codeTable" component={CodeTables} />
      <Route exact path="/codeTable-new" component={CodeTablesNew} />
      <Route exact path="/contactType" component={ContactType} />
      <Route exact path="/unitConversion" component={UnitConversion} />
      <Route
        exact
        path="/GenerateCollectionLetter"
        component={GenerateCollectionLetter}
      />
      <Route
        exact
        path="/Collectionletterdetail"
        component={Collectionletterdetail}
      />
      <Route
        exact
        path="/unitConversion-detail"
        component={UnitConversionDetail}
      />
      <Route
        exact
        path="/ProcedureResultDetails"
        component={ProcedureResultDetails}
      />
      <Route exact path="/ProcedureResults" component={ProcedureResults} />
      <Route exact path="/reminderSetup" component={ReminderSetup} />
      <Route
        exact
        path="/reminderRecipients"
        component={ReminderRecipientsComponent}
      />
      <Route
        exact
        path="/systemReminders"
        component={SystemReminderComponent}
      />
      <Route exact path="/tBill" component={TBill} />
      <Route exact path="/client" component={Client} />
      <Route exact path="/maintain" component={Maintain} />
      <Route exact path="/group" component={Group} />
      <Route exact path="/group-maintain" component={GroupMaintain} />
      <Route exact path="/claim" component={claim} />
      <Route exact path="/selected-claim" component={SelectedClaim} />
      <Route exact path="/ndc" component={NDC} />
      <Route exact path="/ndc-details" component={NDCDetails} />
      <Route exact path="/priceType" component={PriceType} />
      <Route exact path="/plan" component={Plan} />
      <Route exact path="/unfreezeInvoice" component={unfreezeInvoice} />
      <Route exact path="/removeSuspendedDt" component={removeSuspendedDt} />
      <Route
        exact
        path="/reqInitCorrectCmsReport"
        component={ReqInitCorrectCmsReport}
      />
      <Route
        exact
        path="/initCorrectCms64Report"
        component={InitCorrectCmsReport}
      />
      {/* /Manufacturer routes */}
      <Route exact path="/manufacturer" component={ManufacturerSearch} />
      <Route
        exact
        path="/manufacturer-detail"
        component={AddEditManufacturer}
      />
      {/* Maintain > Excluded NDCs */}
      <Route exact path="/excludedNDCs" component={ExcludedNDCsSearch} />
      <Route exact path="/excludedNDCsDetail" component={ExcludedNDCsDetail} />
      <Route exact path="/check" component={CheckSearch} />
      <Route exact path="/checks" component={CheckSearch} />
      <Route exact path="/display-check" component={DisplayCheck} />
      <Route exact path="/maintain-check" component={MaintainCheck} />
      <Route
        exact
        path="/ineligibleProviders"
        component={ineligibleProviders}
      />
      <Route exact path="/provider" component={provider} />
      <Route exact path="/providerDetails" component={ProviderDetails} />
      <Route exact path="/copy-contact" component={CopyContact} />
      <Route exact path="/systemparameter" component={BasicTabs} />
      <Route
        exact
        path="/request-invoice-detail"
        component={RequestInvoiceDetails}
      />
      <Route exact path="/display-invoice" component={DisplayInvoice} />
      <Route
        exact
        path="/requestInvoiceCalculation"
        component={RequestInvoiceCalculation}
      />
      <Route exact path="/SearchViewCheckAllocation" component={SearchCheck} />
      <Route exact path="/checkAllocDetail" component={ViewCheckAllocation} />
      <Route
        exact
        path="/requestURACalculation"
        component={RequestURACalculation}
      />
      <Route
        exact
        path="/createUtilizationTape"
        component={CreateUtilizationTape}
      />
      <Route exact path="/recordMailingDate" component={RecordMailingDate} />
      <Route exact path="/RequestClaimAudit" component={RequestClaimAudit} />
      <Route exact path="/MailingLabel" component={MailingLabel} />
      <Route exact path="/Wip" component={Wip} />
      {/* Tasks > Log Batch Totals */}
      <Route exact path="/logBatchSearch" component={LogBatchTotalSearch} />
      <Route exact path="/logBatchDetail" component={LogBatchTotalForm} />
      <Route exact path="/log-check" component={LogCheckComponent} />
      <Route exact path="/suspendedCheck" component={SuspendedCheckComponent} />
      <Route
        exact
        path="/calculateInterest"
        component={CalculateInterestSearch}
      />
      <Route exact path="/providerReview" component={ProviderReview} />
      <Route
        exact
        path="/providerReviewDetail"
        component={ProviderReviewDetail}
      />
      <Route exact path="/checksByInvoice" component={ChecksByInvoice} />
      <Route exact path="/claimDetails/:id" component={ClaimDetails} />
      <Route exact path="/linknewdrugstodrugfamily" component={LinkNewDrugs} />
      <Route
        exact
        path="/assignDisputesSearch"
        component={AssignDisputesSearch}
      />
      <Route
        exact
        path="/assignDisputesDetails"
        component={AssignDisputesDetails}
      />
      {/* Letter Template */}
      <Route exact path="/letterTemplate" component={LetterTemplateSearch} />
      <Route
        exact
        path="/letterTemplateDetail"
        component={LetterTemplateDetail}
      />
      <Route
        exact
        path="/displayLetterPreview"
        component={DisplayLetterPreview}
      />
      {/* C&C */}
      <Route
        exact
        path="/comment"
        component={CommentAndCorrespondenceComponent}
      />
      <Route exact path="/MaintainCMSMatDrugs" component={maintainMatDrug} />
      <Route exact path="/freezeInvoice" component={FreezeInvoice} />
      <Route exact path="/generateInvoice" component={GenerateInvoice} />
      <Route
        exact
        path="/generateInvoiceDetail"
        component={GenerateInvoiceDetails}
      />
      <Route exact path="/labelerDifferences" component={LabelerDifferences} />
      <Route exact path="/invoiceAudits" component={InvoiceAuditsSearch} />
      <Route
        exact
        path="/invoiceAuditsDetail"
        component={InvoiceAuditViewDetails}
      />
      <Route exact path="/cmsRosi" component={CmsRosiSearch} />
      <Route exact path="/cmsRosiDetails" component={CmsRosiDetails} />
      <Route
        exact
        path="/RequestDrugPriceLoad"
        component={RequestDrugPriceLoad}
      />
      <Route
        exact
        path="/RequestDrugPriceLoadDetails"
        component={RequestDrugPriceLoadDetails}
      />
      {/* Contract */}
      <Route exact path="/disputes" component={DisputesSearch} />
      <Route
        exact
        path="/disputesDetails"
        component={ManufacturerDisputesDetail}
      />
      <Route exact path="/NDCDisputesDetails" component={NDCDisputesDetails} />
      <Route exact path="/technicalWindow" component={TechnicalWindow} />
      <Route
        exact
        path="/claimGroupingParameterDetail"
        component={ClaimGroupingParameterDetail}
      />

      <Route
        exact
        path="/claimGroupingParameter"
        component={ClaimGroupingParameter}
      />
      <Route exact path="/onlineFixes" component={OnlineFixes} />
      <Route exact path="/contactAnomalies" component={ContactAnomalies} />
      <Route
        exact
        path="/cmsDrugFileDiscrepancies"
        component={DrugFileSearch}
      />
      <Route exact path="/cmsDrugFileDetail" component={DrugFileDetails} />
      {/* Contract */}
      <Route exact path="/contract" component={ContractSearch} />
      <Route exact path="/createContract" component={CreateContract} />
      <Route exact path="/cmsMismatch" component={CmsMismatch} />
      <Route
        exact
        path="/underThresholdInvoice"
        component={UnderThresholdInvoiceSearchComponent}
      />
      <Route
        exact
        path="/viewUnderThresholdInvoice"
        component={DisplayUnderThresholdInvoices}
      />
      <Route exact path="/cmsMismatchDetail" component={CmsMismatchDetails} />
      <Route
        exact
        path="/CMSQuarterlyReporting"
        component={ReqQuarterlyReporting}
      />
      <Route
        exact
        path="/DisplayCMSQuarterlyReporting"
        component={DisQuarterlyReporting}
      />
      <Route exact path="/deleteCheckLog" component={DeleteCheckLog} />
      <Route
        exact
        path="/requestedPreviousClaim"
        component={RequestPreviousClaim}
      />
      <Route exact path="/claimAuditSelect" component={claimAuditSelect} />
      <Route exact path="/requestdeletebatch" component={RequestDeleteBatch} />
      <Route exact path="/createStubInvoice" component={CreateStubInvoice} />
      <Route
        exact
        path="/ClaimAuditViewDetails"
        component={ClaimAuditViewDetails}
      />
      <Route exact path="/periodicBalanceRpt" component={PeriodicReport} />
      <Route
        exact
        path="/addordeleteloadlogemail"
        component={AddorDeleteLoadLogEmail}
      />
      <Route exact path="/updateGeneralParam" component={UpdateParamGeneral} />
      <Route exact path="/SearchRebate" component={SearchRebate} />
      <Route exact path="/CreateRebate" component={CreateRebate} />
      {/* PriceLevel */}
      <Route exact path="/priceLevel" component={PriceLevelSearch} />
      {/* Create Letter */}
      <Route exact path="/createLetter" component={CreateLetter} />
      <Route exact path="/createLetterDetail" component={CreateLetterDetail} />
      <Route exact path="/priceDetails" component={MaintainPriceDetails} />
      <Route
        exact
        path="/rosiInconsistencies"
        component={CMSInconsistenciesSearch}
      />
      <Route
        exact
        path="/rosiInconsistenciesDetail"
        component={CMSInconsistenciesDetails}
      />
      <Route
        exact
        path="/requestCurrentDisputeDisplay"
        component={RequestCurrentDisputeDisplay}
      />
      <Route exact path="/providerSummary" component={ProviderSummary} />
      <Route exact path="/ndcHistory" component={NDCHistory} />
      <Route
        exact
        path="/disputedClaimsDetail"
        component={DisputedClaimsDetail}
      />
      <Route
        exact
        path="/displayCurrentDisputes"
        component={DisplayCurrentDisputes}
      />
      {/* Summary Reports */}
      <Route
        exact
        path="/reqInvoicesQtrnotPaid"
        component={RequestInvoicesQtrnotPaid}
      />
      <Route
        exact
        path="/invoicesforQtrnotPaidDetail"
        component={DisplayInvoicesQtrnotPaid}
      />
      {/* PricDetails */}
      <Route exact path="/rebatePriceSearch" component={RebatePriceSearch} />
      <Route exact path="/rebatePriceDetails" component={RebatePriceDetails} />
      <Route exact path="/transitionData" component={TransitionData} />
      <Route
        exact
        path="/view-calculated-interest"
        component={CalculatedInterest}
      />
      <Route
        exact
        path="/calculated-interest-details"
        component={CalculatedInterestDetails}
      />
      <Route exact path="/letter" component={DisplayLetterSearch} />
      <Route exact path="/ura-search" component={URASearch} />
      <Route exact path="/selected-ura" component={SelectedURA} />
      <Route
        exact
        path="/displayLetterDetail"
        component={DIsplayLetterDetail}
      />
      <Route
        exact
        path="/quarterlyMarketingData"
        component={QuarterlyMarketingData}
      />
      <Route
        exact
        path="/quarterlyMarketingDataTableDetails"
        component={QuarterlyMarketingDataTableDetails}
      />
      <Route exact path="/rebatesummary" component={RebateSummary} />
      <Route exact path="/paymentSummary" component={PaymentSummary} />
      <Route
        exact
        path="/displaypaymentSummary"
        component={DisplayPaymentSummary}
      />
      <Route exact path="/percentSpend" component={RebatePercentOfSpend} />
      <Route exact path="/invoiceRegister" component={InvoiceRegister} />
      <Route exact path="/maufacturer" component={DisplayPercent} />
      <Route exact path="/invoice/:id" component={DisplayInvoiceRegister} />
      <Route exact path="/topBalances" component={TopBalances} />
      <Route exact path="/displaytopbalances" component={DisplayTopBalances} />
      <Route exact path="/disputeActivity" component={DisputeActivity} />

      <Route
        exact
        path="/displayDisputeActivity"
        component={DisplayDisputeActivity}
      />
      <Route exact path="/drugTypeSummary" component={DrugTypeSummary} />
      <Route exact path="/displayDrugTypeSummary" component={DisplayDrug} />
      <Route exact path="/unallocatedBalance" component={UnallocatedBalance} />
      <Route
        exact
        path="/unallocated-balance-report"
        component={UnallocatedBalanceDisplay}
      />
      <Route exact path="/disputeAmounts" component={RequestDisputeAmount} />
      <Route
        exact
        path="/displayManufacturerDisputedAmounts"
        component={DisplayManufacturerDisputedAmounts}
      />

      <Route
        exact
        path="/hcpcsCodeClaimsPaid"
        component={HcpcsCodeClaimsPaid}
      />
      <Route exact path="/displayHcpcsCode" component={DisplayHcpcsCode} />
      <Route exact path="/dispCurrentZeroURA" component={DispCurrentZeroURA} />
      <Route exact path="/currentZeroURA" component={ReqCurrentZeroURA} />
      <Route
        exact
        path="/allocatePayment"
        component={SearchAllocatePaymentComponent}
      />
      <Route
        exact
        path="/pickInvoiceAssociateWithCheck"
        component={SearchPickInvAssociateWithCheckCom}
      />
      <Route
        exact
        path="/allocatePaymentDetail/:id"
        component={DetailScreenAllocatePaymentComponent}
      />
      <Route
        exact
        path="/quarterlyPayment1"
        component={RequestQuarterlyPayment1}
      />
      <Route
        exact
        path="/quarterlyPaymentDisplay"
        component={DisplayQuarterlyPayments}
      />

      <Route
        exact
        path="/interestOverride"
        component={InterestOverrideRequest}
      />
      <Route
        exact
        path="/interestOverrideDetail"
        component={InterestOverrideDetail}
      />
      <Route
        exact
        path="/checkallocationcomparison"
        component={CheckAllocationComparisionSearch}
      />
      <Route
        exact
        path="/checkallocationcomparisiondispaly"
        component={CheckAllocationComparisionDisplay}
      />
      <Route exact path="/ndcdetails" component={ReqNDCDetails} />
      <Route exact path="/ndcdetailsdisplay" component={DisplayNDCDetails} />
      <Route exact path="/zeroURA" component={ReqZeroURA} />
      <Route exact path="/dispZeroURA" component={DispZeroURA} />
      <Route
        exact
        path="/disputeRecapitulation"
        component={DisputeRecapitulation}
      />
      <Route
        exact
        path="/displayDisputeRecapitulation"
        component={DisplayDisputeRecapitulation}
      />
      <Route
        exact
        path="/interestRecieved"
        component={InterestRecievedRequest}
      />
      <Route
        exact
        path="/interestRecivedDetail"
        component={InterestRecievedDetail}
      />
      <Route exact path="/disputeCodes" component={DisputeCodes} />
      <Route
        exact
        path="/displayDisputeCodes"
        component={DisplayDisputeCodes}
      />
      <Route
        exact
        path="/outstandingDisputesForQuarter"
        component={OutstandingDisputesForQuarter}
      />

      <Route
        exact
        path="/displayOutstandingDisputesForQuarter"
        component={DisplayOutstandingDisputesForQuarter}
      />
      <Route
        exact
        path="/outstandingDisputesForNumOfDays"
        component={ReqOutstandingDisputesNumOfDays}
      />
      <Route
        exact
        path="/dispOutstandingDisputeNumOfDays"
        component={DispOutstandingDisputesNumOfDays}
      />
      <Route
        exact
        path="/researchexisitngcms64report"
        component={ResearchExistingCMSReport}
      />
      <Route
        exact
        path="/researchexisitngcms64reportdetails"
        component={ResearchExistingCMS64ReportDetails}
      />
      <Route
        exact
        path="/researchExistingCMS64InvoiceAmount"
        component={ResearchExistingCMS64InvoiceAmount}
      />
      <Route
        exact
        path="/researchExistingCMS6Adjustments"
        component={ResearchExistingCMS64Adjustments}
      />
      <Route
        exact
        path="/researchExistingCMS6Payments"
        component={ResearchExistingCMS64Payments}
      />
      <Route exact path="/ndchistoryreport" component={ReqNDCHistory} />
      <Route exact path="/ndchistorydisplay" component={DisplayNDCHistory} />
      <Route exact path="/mco_claims" component={RequestMCOClaims} />
      <Route
        exact
        path="/adjustmentByReasonCode"
        component={AdjustmentByReasonCode}
      />
      <Route
        exact
        path="/dispAdjustmentByReasonCode"
        component={DispAdjustmentReasonCode}
      />
      <Route
        exact
        path="/institionalClaimsTypeDiscrepancy"
        component={ReqInstitutionalClaim}
      />
      <Route
        exact
        path="/dispInstitionalClaimsTypeDiscrepancy"
        component={DispInstitutionalClaim}
      />

      <Route exact path="/contractreport" component={RequestContract} />
      <Route exact path="/display_mco_claims" component={DisplayMCOClaims} />
      <Route exact path="/rosi_pqas" component={Rosi} />
      <Route exact path="/displayrosi_pqas" component={DisplayRosi} />
      <Route exact path="/displaycmsUra" component={DisplayCms} />
      <Route exact path="/displayCmsDrug" component={DisplayCmsDrug} />

      <Route exact path="/cmsUra" component={CmsUra} />
      <Route exact path="/cmsDrug" component={CmsDrug} />
      <Route
        exact
        path="/request-invoice-report"
        component={RequestInvoiceReport}
      />
      <Route
        exact
        path="/invoice-report-details"
        component={RequestInvoiceReportDetails}
      />
      <Route
        exact
        path="/display340BProviderClaims"
        component={DisplayBprovider}
      />

      <Route exact path="/340BProviderClaims" component={BProviderClaim} />
      <Route
        exact
        path="/programAndEligibilityCategory"
        component={ProgramAndEligibility}
      />
      <Route
        exact
        path="/displayProgramAndEligibilityCategory"
        component={DisplayProgramAndEligibility}
      />
      <Route exact path="/totaldollarspaid" component={TotalDollersPaid} />
      <Route exact path="/PreInvoiceUnitAdjustment" component={PreInvoice} />
      <Route
        exact
        path="/DisplayPreInvoiceUnitAdjustment"
        component={DisplayPreInvoice}
      />
      <Route
        exact
        path="/currentToPreviousQuarterInvoiceComparison"
        component={RequestCurrentToPrevious}
      />
      <Route
        exact
        path="/displayCurrentToPreviousQuarterInvoiceComparison"
        component={DisplayCurrentToPrevious}
      />
      <Route path="/cashReceiptSummary" component={ReqCashReceiptSummary} />
      <Route
        exact
        path="/dispCashReceiptSummary"
        component={DispCashReceiptSummary}
      />
      <Route exact path="/cmsReportAdjustmentDetail" component={CmsReport} />
      <Route
        exact
        path="/displayCmsReportAdjustmentDetail"
        component={DisplayCmsReport}
      />
      <Route
        exact
        path="/outstandingBalanaceByLabererAndQuarter"
        component={ReqOutstandingByLabererAndQuarter}
      />
      <Route
        exact
        path="/manufacturerSummary"
        component={ReqManufacturerSummary}
      />
      <Route
        exact
        path="/dispManufacturerSummary"
        component={DispManufacturerSummary}
      />
      <Route exact path="/ndcPayment" component={ReqNDCPayment} />
      <Route exact path="/dispNDCPayment" component={DispNDCPayment} />
      <Route exact path="/adjustedClaims" component={AdjustedClaims} />
      <Route
        exact
        path="/disOutstandingBalanaceByLabererAndQuarter"
        component={DisOutstandingByLabererAndQuarter}
      />
      <Route
        exact
        path="/DisplayAdjustedClaims"
        component={DisplayAdjustedClaims}
      />
      <Route
        exact
        path="/familyPlanningDrugsInvoicedforRebates"
        component={RequestFamilyPlanningDrugsInvoicedRebates}
      />
      <Route
        exact
        path="/DisplayFamilyPlanningDrugsInvoicedRebates"
        component={DisplayFamilyPlanningDrugsInvoicedRebates}
      />
      <Route
        exact
        path="/familyPlanningDrugsPaymentReceived"
        component={RequestFamilyPlanningDrugsPmtRec}
      />
      <Route
        exact
        path="/DisplayFamilyPlanningDrugsPmtRec"
        component={DisplayFamilyPlanningDrugsPmtRec}
      />
      <Route path="/excludedClaims" component={ReqExcludedClaims} />
      <Route exact path="/dispExcludedClaims" component={DispExcludedClaims} />
      <Route exact path="/chipCshcnRates" component={ReqChipCshcnRates} />
      <Route exact path="/dispChipCshcnReport" component={DispChipCshcnRates} />
      <Route exact path="/activeLabeler" component={ActiveLabeler} />
      <Route
        exact
        path="/displayActiveLabeler"
        component={DisplayActiveLabeler}
      />
      <Route exact path="/userList" component={UserList} />
      <Route
        exact
        path="/terminatedlabeler"
        component={TerminatedLabelerRequest}
      />
      <Route
        exact
        path="/terminatedlabelerdisplay"
        component={TerminatedLabelerDetail}
      />
      <Route
        exact
        path="/quarterlyclaimsreconcilliation"
        component={QuarterlyClaimReconcilliationRequest}
      />
      <Route
        exact
        path="/quarterlyclaimsreconcilliationdetails"
        component={QuarterlyClaimReconcilliationDetail}
      />
      <Route
        exact
        path="/monthlyclaimsreconcilliation"
        component={MonthlyClaimReconcilliationRequest}
      />
      <Route
        exact
        path="/monthlyclaimsreconcilliationdetails"
        component={MonthlyClaimReconcilliationDetail}
      />
      <Route
        exact
        path="/drugsTherapeuticClass"
        component={RequestDrugsTherapeuticClass}
      />
      <Route
        exact
        path="/displayDrugsTherapeuticClass"
        component={DisplayDrugsTherapeuticClass}
      />
      <Route
        exact
        path="/chipCshcnRateAudit"
        component={ReqChipCshcnRateAudit}
      />
      <Route
        exact
        path="/dispChipCshcnRateAudit"
        component={DispChipCshcnRateAudit}
      />
      <Route exact path="/supplementalRates" component={SupplementalRates} />
      <Route
        exact
        path="/displaySupplementalRates"
        component={DisplaySupplementalRates}
      />
      <Route
        exact
        path="/unitAdjustmentatNdcLevel"
        component={UnitAdjustment}
      />
      <Route
        exact
        path="/displayUnitAdjustmentatNdcLevel"
        component={DisplayUnitAdjustment}
      />
      <Route
        exact
        path="/manufacturerOutstandingBalance"
        component={ReqManufacturerOutstandingBal}
      />
      <Route
        exact
        path="/displayManufacturerOutstandingBalance"
        component={DisManufacturerOutstandingBal}
      />
      <Route path="/substanceAbuseDrug" component={SubstanceAbuse} />
      <Route
        exact
        path="/displaSubstanceAbuseDrug"
        component={DisplaySubstanceAbuse}
      />
      <Route exact path="/providerClaimListing" component={DProviderClaim} />
      <Route
        exact
        path="/displayProviderClaimListing"
        component={DisplayDProviderClaim}
      />

      <Route exact path="/rider" component={RequestRider} />

      <Route exact path="/riderdetails" component={DisplayRider} />
      <Route exact path="/units-claim" component={UnitsClaim} />
      <Route
        exact
        path="/units-selected-claim"
        component={UnitsSelectedClaim}
      />
      <Route
        exact
        path="/maintainIneligibleCPT"
        component={MaintainIneligibleCPTComponent}
      />
      <Route
        exact
        path="/requestDataNicheReport"
        component={RequestDataNicheReportComponent}
      />

      <Route exact path="/EventLogging" component={EventLogging} />
      <Route exact path="/about" component={About} />
      <Route exact path="/FooterLinks" component={FOOTERLINKS} />
      <Route exact path="/SiteMap" component={SITEMAP} />
    </React.Fragment>
  );
}
